'use strict';

var Reflux = require('reflux');

var LanguageStore = Reflux.createStore({

  init: function init() {
    var store = this;

    store.translations = {
      /* Pages */
      "login_page_title": "Login",
      "log_out": "Log out",
      "dashboard_page_title": "Dashboard",
      "new_page_title": "Create",
      "details_page_title": "Details",
      "project_page_title": "Project",

      /* General UI */
      "cancel_button": "Cancel",
      "create_button": "Create",
      "edit_button": "Edit",
      "copy_button": "Copy",
      "save_button": "Save",
      "saving_button": "Saving",
      "no_changes_to_save_button": "No changes to save",
      "back_button": "Go Back",
      "select_all_button": "Select all",
      "deselect_all_button": "Deselect all",
      "delete_button": "Delete",
      "for_sale_button": "For sale",
      "not_for_sale_button": "Not for sale",
      "search_field_placeholder": "Search",
      "search_field_description": "Search",

      /* Login */
      "login_title": "ContentBase",
      "login_email_field_placeholder": "Email",
      "login_email_field_description": "Email",
      "login_email_field_invalid": "Email field is invalid",
      "login_password_field_placeholder": "Password",
      "login_password_field_description": "Password",
      "login_password_field_invalid": "Password field is invalid",
      "login_submit_button": "Log in",

      /* Dashboard */
      "dashboard_title": "Dashboard",

      /* Team Details */
      "team_details_name_field_description": "Team name",
      "team_details_name_field_placeholder": "Team name",
      "team_details_name_field_missing": "Team name is missing",
      "team_details_assigned_projects_title": "Assigned projects",
      "team_details_assigned_projects_missing_title": "No projects assigned to this team",
      "team_details_assigned_datasources_title": "Assigned datasources",
      "team_details_assigned_datasources_missing_title": "No datasources assigned to this team",
      "team_details_assigned_users_title": "Assigned users",
      "team_details_assigned_users_missing_title": "No users assigned to this team",
      "team_details_delete_confirmation": "Are you sure you want to delete the team?",

      /* User Details */
      "user_details_name_field_description": "Name",
      "user_details_name_field_placeholder": "Name",
      "user_details_name_field_missing": "Name field is missing",
      "user_details_email_field_description": "Email",
      "user_details_email_field_placeholder": "Email",
      "user_details_email_field_missing": "Email field is missing",
      "user_details_email_field_exists": "A user with this email exists",
      "user_details_api_token_field_description": "API token",
      "user_details_api_token_field_placeholder": "API token",
      "user_details_assigned_projects_title": "Assigned projects",
      "user_details_assigned_projects_missing_title": "No projects assigned to this user",
      "user_details_assigned_teams_title": "Assigned teams",
      "user_details_assigned_teams_missing_title": "No teams assigned to this user",
      "user_details_assigned_datasources_title": "Assigned datasources",
      "user_details_assigned_datasources_missing_title": "No datasources assigned to this user",
      "user_details_delete_confirmation": "Are you sure you want to delete the user?",

      /* Datasource Details */
      "datasource_details_name_field_description": "Datasource name",
      "datasource_details_name_field_placeholder": "Datasource name",
      "datasource_details_contents_field_description": "Contents",
      "datasource_details_assigned_projects_title": "Assigned projects",
      "datasource_details_assigned_projects_missing_title": "No projects assigned to this datasource",
      "datasource_details_assigned_teams_title": "Assigned teams",
      "datasource_details_assigned_teams_missing_title": "No teams assigned to this datasource",
      "datasource_details_assigned_users_title": "Assigned users",
      "datasource_details_assigned_users_missing_title": "No users assigned to this datasource",
      "datasource_details_delete_confirmation": "Are you sure you want to delete the datasource?",
      "datasource_details_items_missing_title": "No content yet in this datasource",
      "datasource_details_items_create": "Create content",
      "datasource_details_items_delete_confirmation": "Are you sure you want to delete the selected items?",

      /* Project Details */
      "project_details_name_field_description": "Project name",
      "project_details_name_field_placeholder": "Project name",
      "project_details_name_field_missing": "Project name is missing",
      "project_details_delete_modules_confirmation": "Are you sure you want to delete this module and its connections?",
      "project_details_delete_connections_confirmation": "Are you sure you want to delete this connection?",
      "project_details_delete_confirmation": "Are you sure you want to permanently delete this project?",
      "project_details_copy_confirmation": "Are you sure you want to copy this project?",
      "project_details_copy_button": "Copy project",
      "project_details_copy_name_field_description": "Copy name",
      "project_details_copy_name_field_placeholder": "Copy name",
      "project_details_copy_submit_button": "Create copy",
      "project_details_not_found": "No project found",

      /* Project Inspector */
      "inspector_select_none_select": "Nothing selected",
      "inspector_datasource_none_select": "Nothing selected",
      "inspector_image_empty": "Drop an image file here",
      "inspector_image_failed_to_load": "Failed to load image",
      "inspector_image_loading": "Loading image",

      /* Translation Editor */
      "translation_editor_edit_link": "Edit link",
      "translation_editor_add_link": "Add link",
      "translation_editor_link_field_description": "Link url",
      "translation_editor_link_field_placeholder": "Enter the link url here",
      "translation_editor_remove_link_button": "Remove link from selection",
      "translation_editor_add_link_button": "Add link to selection",
      "translation_editor_delete_property_warning": "Are you sure you want to delete this property and all of its children?",

      /* Module List */
      "module_list_empty": "No modules available",

      /* Content Editor */
      "content_editor_enter_key": "Enter the key you would like to add.",
      "content_editor_enter_key_error_empty": "You have to specify a key.",
      "content_editor_enter_key_error_overwrite": "The specified key already exists.",
      "content_editor_unspecified_error": "Something went wrong. Please try again."
    };
  },

  translate: function translate(key) {
    var store = this;
    var translations = store.translations;

    var translation = translations[key];

    if (translation === undefined) {
      return '[' + key + ']';
    }

    return translation;
  },

  hasTranslation: function hasTranslation(key) {
    var store = this;
    var translations = store.translations;

    return translations[key] !== undefined;
  }
});

module.exports = LanguageStore;


/** WEBPACK FOOTER **
 ** ../~/babel-loader!./js/stores/language.js
 **/